// Pure math between the placement contract (PDF points, bottom-left origin,
// x/y = the box's bottom-left corner) and CSS pixels (top-left origin) at the
// current render scale. Placements are only rewritten when an interaction
// commits — loading and zooming never round-trip stored numbers through
// pixels — so values can't drift across sessions.

// The font defaults and limits match the renderer's defaults and the
// contract's allowed range (SmartFieldPlacement::FONT_SIZE_RANGE).
export const DEFAULT_FONT_SIZE = 10
export const MAX_FONT_SIZE = 72
export const MIN_FONT_SIZE = 6
export const MIN_HEIGHT_PT = 8
// The stamper shrinks text to fit but raises below ~6pt, so keep boxes big
// enough that a couple of characters always fit.
export const MIN_WIDTH_PT = 20

export function clampToPage({ page, placement }) {
  const height = round1(clamp(placement.height, MIN_HEIGHT_PT, page.height))
  const width = round1(clamp(placement.width, MIN_WIDTH_PT, page.width))
  return {
    ...placement,
    height,
    width,
    x: round1(clamp(placement.x, 0, page.width - width)),
    y: round1(clamp(placement.y, 0, page.height - height)),
  }
}

export function round1(value) {
  return Math.round(value * 10) / 10
}

export function toCss({ page, placement, scale }) {
  return {
    height: placement.height * scale,
    left: placement.x * scale,
    top: (page.height - placement.y - placement.height) * scale,
    width: placement.width * scale,
  }
}

// rect is {height, left, top, width} in CSS pixels relative to the page's
// top-left corner (i.e. offset within the page element).
export function toPoints({ page, rect, scale }) {
  const height = round1(rect.height / scale)
  return {
    height,
    width: round1(rect.width / scale),
    x: round1(rect.left / scale),
    y: round1(page.height - rect.top / scale - height),
  }
}

function clamp(value, min, max) {
  return Math.min(Math.max(value, min), Math.max(max, min))
}
